import { FC } from 'react';
import { Control, useWatch } from 'react-hook-form';

import { ChevronDownIcon } from '../../../../../../../assets/icons/index';
import { AppFormattedMessage } from '../../../../../../../components/app-formatted-message/index';
import {
  ComboboxButton,
  ComboboxOptions,
  FormCombobox,
  FormComboboxInput,
  FormComboboxOption,
} from '../../../../../../../components/combobox/index';
import { useLocale } from '../../../../../../../hooks/index';
import { subCategoryByCategory } from '../../../../constants/add-template-form-options.constant';
import { AddTemplateFormSchema } from '../../../../validations/add-template.validation';

export type SubCategoryComboboxProps = {
  control: Control<AddTemplateFormSchema>;
  disabled?: boolean;
};

const SubCategoryOptionList: FC<SubCategoryComboboxProps> = ({ control }) => {
  const category = useWatch({ control, name: 'stepOne.category' });
  const options = category ? subCategoryByCategory[category] : [];

  return (
    <>
      {options?.map(({ value, labelKey }) => (
        <FormComboboxOption control={control} key={value} name="stepOne.subCategory" value={value}>
          <span className="text-sm font-normal text-gray-700">
            <AppFormattedMessage id={labelKey} />
          </span>
        </FormComboboxOption>
      ))}
    </>
  );
};

export const SubCategoryCombobox: FC<SubCategoryComboboxProps> = ({ control, disabled }) => {
  const { messagesLocale } = useLocale();
  const category = useWatch({ control, name: 'stepOne.category' });
  const subCategory = useWatch({ control, name: 'stepOne.subCategory' });
  const options = category ? subCategoryByCategory[category] : [];
  const selectedOption = options?.find((o) => o.value === subCategory);
  const displayValue = selectedOption ? messagesLocale[selectedOption.labelKey] : '';

  return (
    <FormCombobox className="relative" control={control} name="stepOne.subCategory">
      <div className="relative">
        <FormComboboxInput
          control={control}
          customValue={() => displayValue}
          disabled={disabled}
          icon={<ChevronDownIcon className="mt-3 h-4 w-4 text-gray-500" />}
          name="stepOne.subCategory"
          placeholder={<AppFormattedMessage id="SUB_CATEGORY" />}
          readOnly
          wrapperClassName="min-h-[56px]"
        />
        <ComboboxButton className="absolute left-0 top-0 z-1 h-full w-full" disabled={disabled} />
      </div>
      <ComboboxOptions className="absolute z-20 w-full rounded border border-gray-200 bg-white p-2 shadow-lg">
        <SubCategoryOptionList control={control} />
      </ComboboxOptions>
    </FormCombobox>
  );
};
